import React from 'react'

interface Props {}

const Checkout: React.FC<Props> = () => {
  return <div>Checkout</div>
}

export default Checkout
